import { Icon } from "../ui/Icon.tsx";
import type { IconName } from "../ui/iconPaths.ts";
import styles from "./Rail.module.css";

export type Section = "chats" | "voxie" | "games" | "settings";

const ITEMS: { section: Section; icon: IconName; label: string }[] = [
  { section: "chats", icon: "chat", label: "Chats" },
  { section: "voxie", icon: "sparkle", label: "Voxie" },
  { section: "games", icon: "games", label: "Spiele" },
];

/** The navigation rail of docs/web-designs screen 2 (the bottom bar below 720 px). */
export function Rail({ active, unread, onSelect }: { active: Section; unread: number; onSelect: (section: Section) => void }) {
  const item = (section: Section, icon: IconName, label: string, badge = 0) => (
    <button key={section} className={active === section ? `${styles.item} ${styles.on}` : styles.item} onClick={() => onSelect(section)} aria-current={active === section}>
      <span className={styles.pill}>
        <Icon name={icon} />
        {badge > 0 && <span className={styles.badge}>{badge > 99 ? "99+" : badge}</span>}
      </span>
      {label}
    </button>
  );
  return (
    <nav className={styles.rail} aria-label="Bereiche">
      <span className={styles.logo}>V</span>
      {ITEMS.map((i) => item(i.section, i.icon, i.label, i.section === "chats" ? unread : 0))}
      <span className={styles.grow} />
      {item("settings", "settings", "Einstellungen")}
    </nav>
  );
}
